import type { SerialRow } from './cartTypes';

/** Source id comes from validated serial (matches backend serialHostId / response.hostApp.id). */
export function isCrossgradeSameHostBlocked(row: SerialRow): boolean {
  const src = row.sourceHostApp?.id;
  const tgt = row.targetHostApp?.id;
  if (!src || !tgt) return false;
  return src === tgt;
}
